import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack mb-6" }
const _hoisted_2 = { class: "d-flex fw-bold my-2 text-fprimary" }
const _hoisted_3 = { class: "ms-4 badge rounded-pill bg-danger" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "...", -1)
const _hoisted_5 = { class: "d-flex my-2 align-items-center" }
const _hoisted_6 = { class: "d-flex align-items-center position-relative me-4" }
const _hoisted_7 = { class: "svg-icon svg-icon-3 position-absolute ms-3" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = {
  key: 0,
  class: "row row-cols-2 row-cols-lg-4 row-cols-xl-4 g-6 g-xl-9 mb-6 mb-xl-9"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "...", -1)
const _hoisted_12 = { class: "card-body d-flex justify-content-center text-center flex-column p-8" }
const _hoisted_13 = {
  href: "#",
  class: "text-gray-800 text-hover-primary d-flex flex-column"
}
const _hoisted_14 = { class: "symbol symbol-60px mb-6" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "fs-4 fw-bold mb-2" }
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_ModalClubs = _resolveComponent("ModalClubs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.t("sports")), 1),
        _createElementVNode("span", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.listSports.length) + " ", 1),
          _hoisted_4
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            type: "text",
            class: "form-control form-control-sm w-300px ps-9 border border-2 border-fprimary border-opacity-25 border-hover-fprimary",
            placeholder: `${_ctx.t('search')}`
          }, null, 8, _hoisted_8), [
            [_vModelText, _ctx.search]
          ])
        ])
      ])
    ]),
    (_ctx.listSports.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSports, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `fl-s-${index}`,
              class: "col"
            }, [
              _createElementVNode("div", {
                class: "card h-100 border border-2 border-fprimary border-hover shadow-sm",
                onClick: ($event: any) => (_ctx.onDialogSport(item))
              }, [
                (item?.quantity)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(`position-absolute top-0 start-100 translate-middle badge rounded-pill bg-f${(item?.quantity>0 ? 'primary' : 'secondary')}`)
                    }, [
                      _createTextVNode(_toDisplayString(item.quantity) + " ", 1),
                      _hoisted_11
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("a", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("img", {
                        src: `/media/svg/files/${'folder-document'}.svg`,
                        alt: ""
                      }, null, 8, _hoisted_15)
                    ]),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "fs-7 fw-semibold text-gray-600 mt-auto",
                    innerHTML: `${item.acronym}`
                  }, null, 8, _hoisted_17)
                ])
              ], 8, _hoisted_10)
            ]))
          }), 128))
        ]))
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: `${_ctx.t('notFoundResult')}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getSports
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('tryAgain')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["description"])), [
          [_directive_loading, _ctx.loader]
        ]),
    _createVNode(_component_ModalClubs, {
      evento: _ctx.evento,
      sport: _ctx.itemSport,
      listSports: _ctx.listSports,
      listStatus: _ctx.listStatus
    }, null, 8, ["evento", "sport", "listSports", "listStatus"])
  ], 64))
}